<template>
    <div class="footer">
        <div class="footer-grids">
            <div class="footer-top">
                <div class="footer-top-nav">
                    <!--<div style="float:left;">-->
                        <!--<a href="http://www.kcc.gov.tw/index.aspx" target="_blank"><img src="@/assets/images/logo_circle.png" alt="啟迪國際資訊股份有限公司"/></a>-->
                    <!--</div>-->
                    <!--<ul>-->
                        <!--<li><router-link :to="{ name: 'StaticService' }">服務條款</router-link></li>-->
                        <!--<li><router-link :to="{ name: 'StaticPrivacy' }">隱私權政策</router-link></li>-->
                        <!--<li><router-link :to="{ name: 'StaticRight' }">著作權聲明</router-link></li>-->
                        <!--<li><router-link :to="{ name: 'StaticObligations' }">會員權利與義務</router-link></li>-->
                    <!--</ul>-->
                </div>

                <div class="footer-bottom-nav">
                    <ul>
                        <li>
                            <a href="https://goo.gl/maps/hubaDLmFCM48Mtiy9" target="_blank">116台北市文山區興隆路二段46號</a></li>
                        <li>電話：(02) 2932-3118</li>
                    </ul>
                </div>

            </div>
            <div class="footer-bottom">
                <ul><li class="device">本站建議使用 GoogleChrome、Firefox 瀏覽；欲使用 IE11 瀏覽，請下載安裝<a href="https://get.adobe.com/tw/flashplayer/" target="_blank" class="flashplayer"> AdobeFlashPlayer</a></li></ul>
                <ul><li><p>Copyright © 2020 <a href="http://www.chjhs.tp.edu.tw/dispPageBox/MainHp.aspx?ddsPageID=MAINHP" target="_blank">臺北市私立靜心高級中學</a> All rights reserved. | <a href="http://www.ginnet.com.tw" target="_blank">啟迪國際影音平台</a></p></li></ul>
            </div>
<!--          <div class="copyright">-->
<!--            <p>Copyright © 2020 <a href="http://www.chjhs.tp.edu.tw/dispPageBox/MainHp.aspx?ddsPageID=MAINHP" target="_blank">臺北市私立靜心高級中學</a> All rights reserved. | <a href="http://www.ginnet.com.tw" target="_blank">啟迪國際影音平台</a></p>-->
<!--          </div>-->
        </div>
    </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
